import { UserRound } from 'lucide-react'
import { Thumbnail } from '../Thumbnail'

export interface SubjectPortraitProps {
  url?: string | null
  /** Size and radius, e.g. `size-12 rounded-xl`. */
  className?: string
}

/**
 * A subject's main photo, or a neutral silhouette when there is none yet. Decorative:
 * the name and tag next to it carry the meaning, so the image has empty alt text.
 */
export function SubjectPortrait({ url, className }: SubjectPortraitProps) {
  return <Thumbnail url={url} alt="" Icon={UserRound} className={className} />
}
